// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Vxsu","title":"InfoRow_title__4VxQ8"};